module.exports = __webpack_public_path__ + "img/te-mision6.a7d934f5.jpg";